import { axios } from '@/utils/axios'
// import _ from 'lodash'
// import moment from 'moment'
import Storage from '@/assets/js/storage'

// 更新乘机人数量
export async function updatePassengerNum (params) {
  try {
    return await axios.post('/api/order/passengerNum/update', params)
  } catch (error) {
    return Promise.reject(error)
  }
}

// 下单流程-新增乘客信息
export async function addPassengerInfo (params) {
  try {
    const result = await axios.post('/api/order/passengerInfo/add', params)
    if (result) {
      Storage.setItem(`SHOPPINGCART_DATA`, result, 0.5 * 3600000)
    }
    return result
  } catch (error) {
    return Promise.reject(error)
  }
}

/**
 * 常用乘机人接口 - 增删改查
 */
export async function queryUsualPassenger (params) {
  try {
    return await axios.post('/api/UniPassenger/query', params)
  } catch (error) {
    return Promise.reject(error)
  }
}

export async function addUsualPassenger (params) {
  try {
    return await axios.post('/api/UniPassenger/add', params)
  } catch (error) {
    return Promise.reject(error)
  }
}

export async function deleteUsualPassenger (params) {
  try {
    return await axios.get(`/api/UniPassenger/delete?id=${params}`)
  } catch (error) {
    return Promise.reject(error)
  }
}

export async function updateUsualPassenger (params) {
  try {
    return await axios.post('/api/UniPassenger/update', params)
  } catch (error) {
    return Promise.reject(error)
  }
}

export async function delPassengerCert (params) {
  try {
    return await axios.get('/api/UniPassenger/del', { params: { ...params } })
  } catch (error) {
    return Promise.reject(error)
  }
}
